export const shopContent = {
  hero: {
    title: "Sacred Soil Alphabet",
    quote: "Words are power. Like fuel and food, they are consumable packages that contain dense information to stimulate action.",
    description: "First Edition • Limited Collection • 26 Letters + Numbers"
  },
  explanation: {
    title: "More Than Art. A Voice in the Movement.",
    text: "Every piece of ERB alphabet art is a stake in a growing movement to regenerate Earth's soil. When you collect, you:",
    receive: [
      { label: "Join the founding community", desc: "Be part of the movement from day one" },
      { label: "Own scarce first-edition art", desc: "Limited supply, lasting value" },
      { label: "Fund soil regeneration", desc: "Proceeds support the mission" },
      { label: "Help build certification", desc: "Your purchase grows our ability to certify regenerative businesses" }
    ]
  },
  assets: [
    ...Array.from({ length: 26 }, (_, i) => ({
      type: 'Letter',
      char: String.fromCharCode(65 + i),
      name: `Frequency: ${String.fromCharCode(65 + i)}`,
      price: '0.23 SOL | $55',
      // Using keyword-based images for stability
      img: `https://images.unsplash.com/photo-${1511497584788 + (i % 20)}?auto=format&fit=crop&q=80&w=800`,
      marketplaceUrl: 'https://magiceden.io/marketplace/erb_alphabet',
      variantId: `variant_${i}` 
    })),
    ...Array.from({ length: 10 }, (_, i) => ({
      type: 'Number',
      char: i.toString(),
      name: `Frequency: ${i}`,
      price: '0.23 SOL | $55',
      img: `https://images.unsplash.com/photo-${1544377193 + (i % 10)}?auto=format&fit=crop&q=80&w=800`,
      marketplaceUrl: 'https://magiceden.io/marketplace/erb_alphabet',
      variantId: `variant_num_${i}`
    })),
    { 
      type: 'Phrase', 
      char: '∑', 
      name: 'Mantra: SOIL', 
      price: '0.45 SOL | $95', 
      img: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&q=80&w=800', 
      marketplaceUrl: 'https://magiceden.io/marketplace/erb_alphabet', 
      variantId: 'variant_phrase_soil' 
    },
    { 
      type: 'Phrase', 
      char: '∆', 
      name: 'Mantra: EARTH', 
      price: '0.45 SOL | $95', 
      img: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&q=80&w=800', 
      marketplaceUrl: 'https://magiceden.io/marketplace/erb_alphabet', 
      variantId: 'variant_phrase_earth' 
    },
  ],
  closing: {
    quote: "Your ownership of ERB art is an autograph giving earth the right to eat a digestible form of human creativity. Represented in your wallet where it matters most.",
    description: "Contact us"
  }
};